/**Dependencies */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { calculateBookingDates } from '../helpers';

/**Components */
import { Swiper, SwiperSlide } from "swiper/react";
import { elementoPorSeccion } from '../services/adminProductService';
import { Navigation } from 'swiper/modules';

/**Images */
import { IoIosArrowForward, IoIosArrowBack  } from "react-icons/io";

export const CarouselHotels = ({title, idElemento, arrPosition}) => {

  const [imgsBanners, setImgsBanners] = useState([]);
  const { checkIn, checkOut } = calculateBookingDates();
  
  useEffect(() => {
    const fetchElemento = async () => {
      try {
        const response = await elementoPorSeccion(idElemento);

        const formattedImages = response[arrPosition].imagenes.map((img) => ({
          image: img.url,
          texto: img.texto
        }));
        
        setImgsBanners(formattedImages);
      } catch (err) {
        console.error('Error al cargar las imágenes:', err);
      }
    };

    fetchElemento();
    
  }, [idElemento]);

  return (
    <div className='container py-5'>          
          <div className="text-center mb-5">
            <h1 className='section-title'>{title}</h1>            
          </div>    
          <div className="slider-container carousel-container pb-5">
            <div className="custom-prev" id='prev-hotels'><IoIosArrowBack /></div>
            <Swiper
              navigation={{
                nextEl: '#next-hotels',
                prevEl: '#prev-hotels',
              }}
              spaceBetween={8} 
              slidesPerView={1} 
              loop={true} 
              autoplay={{ delay: 3000 }}
              modules={[Navigation]}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  
                },
                768: {
                  slidesPerView: 2,
                  
                },
                1024: {
                  slidesPerView: 3.5,
                  
                },            
              }}
            >
              {imgsBanners?.map((image, index) => (
                <SwiperSlide key={index}>
                  <Link to={`/hotel?idHotel=${image?.texto}&in=${checkIn}&out=${checkOut}&hab=1&pax1=2|0|0`} >
                    <img src={`https://panel.internationaltravelnet.com.mx/assets/uploads/elementos/${image?.image}`} alt={`Imagen ${index + 1}`} style={{ width: "100%", height: "400px" }} />
                  </Link>
                </SwiperSlide>
                
              ))}
            </Swiper>
            <div className="custom-next" id='next-hotels'><IoIosArrowForward/></div>
          </div>                          
    </div>
  )
}
